<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="总交易单数" prop="sumBill">
        <el-input v-model="form.sumBill" placeholder="请输入总交易单数" v-trim/>
      </el-form-item>
      <el-form-item label="退款的订单数" prop="sumRefundBill">
        <el-input v-model="form.sumRefundBill" placeholder="请输入退款的订单数" v-trim/>
      </el-form-item>
      <el-form-item label="应结订单总金额" prop="sumSuccessFee">
        <el-input v-model="form.sumSuccessFee" placeholder="请输入应结订单总金额" v-trim/>
      </el-form-item>
      <el-form-item label="退款总金额" prop="sumRefundFee">
        <el-input v-model="form.sumRefundFee" placeholder="请输入退款总金额" v-trim/>
      </el-form-item>
      <el-form-item label="充值券退款总金额" prop="sumCouponRefundFee">
        <el-input v-model="form.sumCouponRefundFee" placeholder="请输入充值券退款总金额" v-trim/>
      </el-form-item>
      <el-form-item label="手续费总金额" prop="sumCmmsAmt">
        <el-input v-model="form.sumCmmsAmt" placeholder="请输入手续费总金额" v-trim/>
      </el-form-item>
      <el-form-item label="订单总金额" prop="sumTotalFee">
        <el-input v-model="form.sumTotalFee" placeholder="请输入订单总金额" v-trim/>
      </el-form-item>
      <el-form-item label="申请退款总金额" prop="sumApplyRefundFee">
        <el-input v-model="form.sumApplyRefundFee" placeholder="请输入申请退款总金额" v-trim/>
      </el-form-item>
      <el-form-item label="退款手续费总金额" prop="sumRefundCmmsAmt">
        <el-input v-model="form.sumRefundCmmsAmt" placeholder="请输入退款手续费总金额" v-trim/>
      </el-form-item>
      <el-form-item label="结算金额" prop="total">
        <el-input v-model="form.total" placeholder="请输入结算金额" v-trim/>
      </el-form-item>
      <el-form-item label="自行车收入" prop="bikeFee">
        <el-input v-model="form.bikeFee" placeholder="请输入自行车收入" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaAliBillWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        sumBill: '',
        sumRefundBill: '',
        sumSuccessFee: '',
        sumRefundFee: '',
        sumCouponRefundFee: '',
        sumCmmsAmt: '',
        sumTotalFee: '',
        sumApplyRefundFee: '',
        sumRefundCmmsAmt: '',
        total: '',
        bikeFee: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/aliBill',
      'field.id': 'id'
    })
  }
}
</script>
